import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import { getAllRecordsPayment } from "../../../services/Sales/InvoiceServices";
import Modal from "react-bootstrap/Modal";
import { logSalesPaymentHistory } from "../../../services/index";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Loader from "../../Common/Loader";

const PaymentList = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [logData, setLogData] = useState({});

  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState([]);
  const [dataId, setDataId] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const countPerPage = 10;

  const columns = [
    {
      name: "PAYMENT DATE",
      selector: (data) => data.paymentDate,
    },
    {
      name: "PAYMENT NO.",
      selector: (data) => data.paymentNo,
    },
    {
      name: "INVOICE NO.",
      selector: (data) => data.invoiceNo,
    },
    {
      name: "CUSTOMER NAME",
      selector: (data) => data.customerTitle,
    },
    {
      name: "AMOUNT RECEIVED",
      selector: (data) => data.amountReceived?.toFixed(2),
    },
  ];

  const handleModel = (id) => {
    handleShow();
    logSalesPaymentHistory(id).then((res) => {
      if (res.errorCode === 0) {
        const d = res.responsePacket;
        setLogData(d);
      } else {
        toast(res.message);
      }
    });
  };

  const PaymentList = () => {
    let list_data = {
      page: 0,
      size: -1,
      search: "",
    };
    setLoading(true)
    getAllRecordsPayment(list_data).then((res) => {
      if (res.errorCode === 0) {
        setRecords(res.responsePacket);
        const d = res.responsePacket.data;
        setData(d);
        setFilteredData(d);
        setLoading(false)
      } else {
        setLoading(false)
        toast.error(res.message);
      }
    }).catch(error=> setLoading(false));
  };

  useEffect(() => {
    PaymentList();
  }, [page]);

  useEffect(() => {
    const result = data.filter((data) => {
      return (
        data.customerTitle.toLowerCase().includes(search.toLowerCase()) ||
        data.invoiceNo.toLowerCase().includes(search.toLowerCase()) ||
        data.paymentDate.toLowerCase().includes(search.toLowerCase())
      );
    });
    setFilteredData(result);
  }, [search]);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          Log History
          <hr />
          <table>
            {logData.length === 0 ? (
              "No Changes Found"
            ) : (
              <tr>
                <td>Date</td>
                <td>Changes</td>
              </tr>
            )}
            {logData.length >= 1 &&
              logData?.map((history) => {
                return (
                  <>
                    <tr>
                      <td style={{ alignItems: "start" }}>
                        {history?.transactionDate?.substring(0, 10)}
                        :&nbsp;&nbsp;
                      </td>

                       <td>
                          {history?.message.split("\n").map((b, i) => (
                            <tr key={i}>
                             {b.includes("\t") ? (
                              <div style={{ marginLeft: "20px" }}>{b}</div>
                            ) : b.includes("\t\t") ? (
                              <div style={{ marginLeft: "40px" }}>{b}</div>
                            ) : (
                              b
                            )}
                            </tr>
                          ))}
                        </td>
                    </tr>
                    <hr />
                  </>
                );
              })}
          </table>
        </Modal.Body>
      </Modal>

      <div className="table-responsive overflow-initial customviews-table  ">
        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            title="All Payments"
            columns={columns}
            data={filteredData}
            pagination
            fixedHeader
            pointerOnHover={true}
            highlightOnHover={true}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page)}
            onRowClicked={(data) => {
              handleModel(data.recordId);
            }}
            progressPending={loading}
            progressComponent={<Loader />}
            subHeader
            subHeaderComponent={
              <>
                {" "}
                <SearchRoundedIcon />
                <input
                  autoComplete="off"
                  className="ember-text-field ember-view form-control col-2"
                  type="text"
                  placeholder={"Search here"}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default PaymentList;
